var map = {
	"./agency.svg": "e45b",
	"./cancel.svg": "8ed3",
	"./demand.svg": "f84d",
	"./empty.svg": "c091",
	"./heart.svg": "c40a",
	"./identity.svg": "1a88",
	"./invoice.svg": "0543",
	"./lock.svg": "ab00",
	"./mail.svg": "26f5",
	"./menu.svg": "bd3d",
	"./message.svg": "47ff",
	"./mobile.svg": "30d4",
	"./my-service.svg": "0df8",
	"./notify.svg": "5448",
	"./order.svg": "11ff",
	"./position.svg": "15be",
	"./user.svg": "b3b5",
	"./warning.svg": "7e6f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";